module.exports = __webpack_public_path__ + "img/search-results.9e35120a.png";